import { Pipe, PipeTransform } from '@angular/core';
import { CardModel, JobModel } from 'src/app/models';

@Pipe({ name: 'toJobCards' })
export class JobCardsPipe implements PipeTransform {
  transform(values: JobModel[]): CardModel[] {
    return values?.map((job) => CardModel.fromJobModel(job));
  }
}
